import { LegalDoc } from "@/components/app/LegalDoc";
import { TERMS_OF_USE } from "@/data/legal";

export default function TermsOfUse() {
  return (
    <LegalDoc
      title="Terms of Use"
      body={TERMS_OF_USE}
      testId="terms-of-use-page"
      otherLabel="Privacy Policy"
      otherTo="/privacy"
    />
  );
}
